import React from 'react';
import { useLocation } from 'react-router';

const Page404 = () => {
    const location = useLocation();
    return <h1>Page {location.pathname} not found</h1>;
};

export default Page404;
